import site from "./site.json";
import legal from "./legal.json";

export { site, legal };

/** Valores aún marcados "COMPLETAR ..." en site.json se tratan como vacíos (no se muestran). */
export function filled(v) {
  const s = String(v ?? "").trim();
  return s && !s.includes("COMPLETAR") ? s : "";
}

export const empresa = Object.fromEntries(
  Object.entries(site.empresa).map(([k, v]) => [k, filled(v)]),
);

export const razonSocialVisible = empresa.razonSocial || site.marca;

export function direccionCompleta(e = empresa) {
  return [e.direccion, e.comuna, e.ciudad, e.pais].filter(Boolean).join(", ");
}

function identificacion() {
  let s = razonSocialVisible;
  if (empresa.rut) s += `, RUT ${empresa.rut}`;
  const dir = direccionCompleta();
  if (dir) s += `, con domicilio en ${dir}`;
  return s;
}

const TOKENS = {
  marca: site.marca,
  sitio: site.sitio.replace(/^https?:\/\//, ""),
  razonSocial: razonSocialVisible,
  rut: empresa.rut,
  identificacion: identificacion(),
  direccionCompleta: direccionCompleta(),
  email: empresa.email,
  emailFacturacion: empresa.emailFacturacion,
  telefono: empresa.telefono,
  actualizado: site.legal.actualizado,
  diasDesistimiento: site.legal.diasDesistimiento,
  diasRespuestaReclamos: site.legal.diasRespuestaReclamos,
};

export function fillTokens(text) {
  return String(text ?? "").replace(/\{(\w+)\}/g, (m, k) => (k in TOKENS ? String(TOKENS[k]) : m));
}

export function formatPlanPrice(plan, moneda = site.precios.moneda) {
  if (plan.aMedida) return { monto: "A medida", sufijo: "Cotización según contrato" };
  if (plan.precioMensual == null || plan.precioMensual === "") {
    return { monto: "Consultar", sufijo: `${moneda} / mes` };
  }
  return { monto: `${moneda} ${plan.precioMensual}`, sufijo: "por mes" };
}

export function telHref(tel) {
  const digits = String(tel || "").replace(/[^\d+]/g, "");
  return digits.length >= 8 ? `tel:${digits}` : null;
}
